import * as classNames from "classnames";
import * as React from "react";
import { Box } from "signoxe/components/layout";
import { Button, Icon, Switch, TagList } from "signoxe/components/widgets";
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";
import "./styles.scss";

const FilterDropdown = ({
  isActive,
  isListView,
  isTileView,
  sortedById,
  sortedByName,
  sortedByType,
  assetsSortDirection,
  switchAssetView,
  togg,
  onFilterChange,
  filterByType,
  filterByAspect,
  filterBarVisible,
  changeAssetsSort,
  tags,
  onToggle,
}) => {
  const sortIcon = (
    <Icon
      name={assetsSortDirection ? "sort-desc" : "sort-asc"}
      margin={0}
      size="1.2em"
      color="white"
    />
  );
  return (
    <Dropdown className="button hollow FilterDropdown">
      <DropdownTrigger>
        <Button title="Toggle filter barr" className="FilterDropdown__button">
          <Icon name="gear" margin={0} color="black" />
        </Button>
      </DropdownTrigger>

      <DropdownContent className="filter-menu card depth-2">
        <li>
          <Box
            direction="row"
            alignItems="center"
            className="button-group small"
            wrap
          >
            <Box direction="row" className="label-bx">
              <span className="label secondary">Type:</span>
            </Box>
            <Icon
              name="film"
              size="2rem"
              title="Show only Videos"
              color={filterByType === "video" ? "#88f" : "black"}
              onClick={() => onFilterChange("TYPE", "video")}
            />
            <Icon
              name="picture-o"
              size="2rem"
              title="Show only Images"
              color={filterByType === "image" ? "#88f" : "black"}
              onClick={() => onFilterChange("TYPE", "image")}
            />
            <Icon
              name="code"
              size="2rem"
              title="Show only Web Content"
              color={filterByType === "web" ? "#88f" : "black"}
              onClick={() => onFilterChange("TYPE", "web")}
            />
            <Icon
              name="feed"
              size="2rem"
              title="Show only Feeds"
              color={filterByType === "feed" ? "#88f" : "black"}
              onClick={() => onFilterChange("TYPE", "feed")}
            />
          </Box>
        </li>
        <li>
          <Box
            direction="row"
            alignItems="center"
            className="button-group small"
            wrap
          >
            <Box direction="row" className="label-bx">
              <span className="label secondary">Aspect Ratio:</span>
            </Box>
            <Button
              title="Portrait"
              className={classNames("small", {
                hollow: filterByAspect !== "PORTRAIT",
              })}
              onClick={() => onFilterChange("ASPECT", "PORTRAIT")}
            >
              Portrait
            </Button>
            <Button
              title="Landscape"
              className={classNames("small", {
                hollow: filterByAspect !== "LANDSCAPE",
              })}
              onClick={() => onFilterChange("ASPECT", "LANDSCAPE")}
            >
              Landscape
            </Button>
          </Box>
        </li>
        <li>
          <Box
            direction="row"
            alignItems="center"
            className="button-group small"
            wrap
          >
            <Box direction="row" className="label-bx">
              <span className="label secondary">View as:</span>
            </Box>
            <Button
              className={classNames({ hollow: !isListView })}
              onClick={() => switchAssetView("LIST")}
            >
              List
            </Button>
            <Button
              className={classNames({ hollow: !isTileView })}
              onClick={() => switchAssetView("TILE")}
            >
              Tiles
            </Button>
          </Box>
        </li>

        <li>
          <Box
            direction="row"
            alignItems="center"
            className="button-group small"
            wrap
          >
            <Box direction="row" className="label-bx">
              <span className="label secondary">View Mode:</span>
            </Box>

            <Button
              className={classNames({ hollow: !isTileView })}
              // onClick={() => switchAssetView("STANDARD")}
            >
              Standard
            </Button>

            <Button
              className={classNames({ hollow: !isListView })}
              // onClick={() => switchAssetView("EXPANDED")}
            >
              Expanded
            </Button>
          </Box>
        </li>
        <li>
          <Box
            direction="row"
            alignItems="center"
            className="button-group small"
            wrap
          >
            <Box direction="row" className="label-bx">
              <span className="label secondary">Sort by:</span>
            </Box>
            <Button
              className={classNames({ hollow: !sortedByName })}
              onClick={() => changeAssetsSort("NAME")}
            >
              {sortedByName && sortIcon} Name
            </Button>
            <Button
              className={classNames({ hollow: !sortedByType })}
              onClick={() => changeAssetsSort("TYPE")}
            >
              {sortedByType && sortIcon} Type
            </Button>
            <Button
              className={classNames({ hollow: !sortedById })}
              onClick={() => changeAssetsSort("ID")}
            >
              {sortedById && sortIcon} Time
            </Button>
          </Box>
        </li>

        <li>
          <Box
            direction="row"
            alignItems="center"
            className="button-group small"
            wrap
          >
            <Box direction="row" className="label-bx">
              <span className="label secondary">Resummable Upload : </span>
            </Box>
            <div style={{ marginLeft: "10px" }} onClick={onToggle}>
              <Switch checked={!togg} />
            </div>
          </Box>
        </li>
        <li>
          <Box
            direction="row"
            alignItems="center"
            className="button-group small"
            wrap
          >
            <Box direction="row" className="label-bx">
              <span className="label secondary">Tags:</span>
            </Box>
            <TagList
              tags={tags}
              onTagClick={(tag) => onFilterChange("TAGS", tag)}
            />
          </Box>
        </li>
      </DropdownContent>
    </Dropdown>
  );
};

export default FilterDropdown;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/FilterDropdown/index.js